<script>
import Store from '@/store/index.js'
import Router from '@/router/index.js'
import modalWindow from '@/components/ModalWindow'
import 'bulma/css/bulma.css'
import PasswordLogin from './PasswordLogin'
import { getInvitationFromTeam, getInvitationForAnonymous, getTeamIdsByUserId, addInvitedUserToTeam, deleteInvitedMember } from '@/api/FirebaseTeamWrapper.js'
import * as constant from '@/constant/constant.js'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAuth, signInWithRedirect, GoogleAuthProvider } from 'firebase/auth'
import { getAnalytics, logEvent } from 'firebase/analytics'
import { getMyUserId, getMyUserData, signOutQnQ } from '@/api/FirebaseUserWrapper.js'
import { hasAdminRole } from '@/api/Utilities.js'

const auth = getAuth(firebaseApp)
const analytics = getAnalytics(firebaseApp)
require('../../css/style.css')

const DOMAIN_NAME = 'qnqtree.com'

export default {
  components: {
    modalWindow,
    PasswordLogin
  },
  data () {
    return {
      userId: undefined,
      userData: undefined,
      isAnonymous: undefined,
      createdDone: false,
      enableInvitationModal: false,
      enableAnonymousInvitationModal: false,
      anonymousInvitedMsg: '',
      invitedMsg: '',
      teamId: '',
      invitedEmail: '',
      title: constant.DEFAULT_DOMAIN_TITLE
    }
  },
  async created () {
    this.userId = await getMyUserId()
    this.userData = await getMyUserData(this.userId)
    this.isAnonymous = this.userData.isAnonymous
    await this.checkInvitation()

    if (hasAdminRole) {
      console.log('YOU ARE DEVELOPPER AND EXCLUDED FROM ANALYSIS')
    } else {
      logEvent(analytics, 'join/Join')
    }
    document.title = 'Join | ' + this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', 'Join | ' + this.title)
    this.createdDone = true
  },
  beforeDestroy () {
    document.title = this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', this.title)
  },
  computed: {
    IsLoggingIn () {
      return Store.getters.getIsLoggingIn
    }
  },
  methods: {
    async checkInvitation () {
      // ログイン前の場合は、ログイン用のモーダルを出す
      if (this.isAnonymous) {
        // メッセージをセット
        this.anonymousInvitedMsg = '招待されたチームに参加するためにLoginしてください'
        // チームからの招待状があるかをチェック
        const invitedData = await getInvitationForAnonymous(this.$route.params.invitedId)
        // 招待が存在するかチェック
        if (!invitedData) {
          this.anonymousInvitedMsg = '無効な招待リンクです。招待者へご確認ください'
        }
        // emailによる招待かをチェック
        if (invitedData && invitedData.email) {
          this.invitedEmail = invitedData.email
          this.anonymousInvitedMsg = invitedData.email + 'へ招待が届いています。' + 'チームに参加するためにLoginしてください。'
        }
        this.enableAnonymousInvitationModal = true
      // ログイン済みの場合は、招待状のチェック
      } else {
        // チームからの招待状があるかをチェック
        const invitedData = await getInvitationFromTeam(this.$route.params.invitedId)
        this.teamId = invitedData.teamId
        if (!invitedData) {
          this.invitedMsg = '無効な招待リンクです。招待者へご確認ください。'
          this.enableInvitationModal = true
          return
        }
        if (location.hostname !== DOMAIN_NAME) { console.log('招待メールがあります') }
        // 既にチームメンバーに含まれているかチェック
        const teamIds = await getTeamIdsByUserId(this.userId)
        // 既にチームに所属していたらチーム画面に飛ばす
        if (teamIds.includes(invitedData.teamId)) {
          this.invitedMsg = '既にこのチームに所属しています。チーム管理ページに飛びますか'
          this.enableInvitationModal = true
          return
        }

        if (location.hostname !== DOMAIN_NAME) { console.log('まだチームに所属していない') }

        try {
          await addInvitedUserToTeam(invitedData.teamId)
          await deleteInvitedMember(invitedData.teamId)
          this.invitedMsg = '招待されたチームへメンバーとして追加されました。チーム管理ページに飛びますか'
          this.enableInvitationModal = true
        } catch (err) {
          this.invitedMsg = '招待されたチームへ追加できませんでした。ご迷惑をおかけいたしますが再度お試しください。'
          this.enableInvitationModal = true
          console.log(err)
        }
      }
    },
    clickCancel () {
      this.invitedMsg = ''
      this.enableInvitationModal = false
      this.enableAnonymousInvitationModal = false
    },
    clickAccept () {
      this.invitedMsg = ''
      this.enableInvitationModal = false
      Router.push({ path: '/editteam/' + this.teamId })
    },
    googleLogin: async function () {
      Store.commit('setIsLoggingIn', true)
      signInWithRedirect(auth, new GoogleAuthProvider())
    },
    async logout () {
      try {
        await signOutQnQ()
      } catch (error) {
        console.error(error)
      }
      location.reload(true)
    },
    async updateUserInfo () {
      this.userId = await getMyUserId()
      this.userData = await getMyUserData(this.userId)
      this.isAnonymous = this.userData.isAnonymous
      await this.checkInvitation()
    }
  }
}
</script>
<style scoped>
.join {
  margin: auto;
  max-width: 1024px;
  padding: 1.0rem;
}
.password-login {
  margin: auto;
  max-width: 400px;
}
.is-size-8 {
  font-size: 0.5rem !important;
}
</style>
<template>
  <div v-if="(!IsLoggingIn) && createdDone" class="join">
    <label class="label">QnQTree</label>
    <br/>
    <p class='text has-text-wight-bold'>QnQTreeでチームに参加する</p>
    <br>
    <div class="login" v-if="isAnonymous">
      <div id="gmail-login">
        <div class="button is-link is-outlined has-text-weight-bold" v-on:click="googleLogin">
          <span class="image is-24x24 has-text-left">
            <img class="is-rounded" src="./img/g-logo.png" alt="Placeholder image">
          </span>
          &nbsp;
          &nbsp;
          <span>GoogleでLogin</span>
        </div>
        <br>
      </div>
      <!-- SignUp & SignIN -->
      <hr>
      <PasswordLogin class="password-login"
      :isAnonymous = "isAnonymous"
      :invitedEmail = "invitedEmail"
      @updateUserInfo = "updateUserInfo"
      />
      <br>
      <br>
      <br>
      <br>
      <p class="text is-size-8">
        <router-link to="privacy">プライバシポリシー</router-link>に同意してログインする
      </p>
    </div>
    <br>
    <div class="invite-modal-window">
      <modalWindow @close="clickCancel()" v-if="enableInvitationModal">
        <template slot="header">
          <div class="buttons is-right">
            <button class="delete" @click="clickCancel()"></button>
          </div>
        </template>
        <p>{{invitedMsg}}</p>
        <template slot="footer">
          <div class="buttons is-centered">
            <button class="button is-link" @click="clickAccept()">はい</button>
          </div>
        </template>
      </modalWindow>
    </div>
    <div class="invite-modal-window">
      <modalWindow @close="clickCancel()" v-if="enableAnonymousInvitationModal">
        <template slot="header">
          <div class="buttons is-right">
            <button class="delete" @click="clickCancel()"></button>
          </div>
        </template>
        <p>{{anonymousInvitedMsg}}</p>
        <template slot="footer">
          <div class="buttons is-centered">
            <button class="button is-link" @click="clickCancel()">はい</button>
          </div>
        </template>
      </modalWindow>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/join/Join.vue